import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: string;
    loading: string;
    defaultNameFallback: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error toast shown when creating an upload link fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateUploadLink.error?c=2rprvy6j5gcup", defaultMessage: "Something went wrong. Upload Link was not created." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Loading toast title shown while an upload link is being created */
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateUploadLink.loading?c=24c06n1old6ux", defaultMessage: "Creating upload link\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Fallback default name when the target folder's name is unknown */
            defaultNameFallback: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateUploadLink.defaultNameFallback?c=1zl2tj2d0he40", defaultMessage: "Upload Link" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
